module.exports = __webpack_public_path__ + "img/voiscooter.b4c2d827.webp";